module.exports = __webpack_public_path__ + "static/media/equalicare-img16.022f3615.png";